import * as React from 'react';

import loadableBase, { LoadableComponent, OptionsWithoutResolver, DefaultComponent } from '@loadable/component';

import Loader from '@common/react/components/Core/LoaderProvider/Loader';
import SimpleLoader from '@common/react/components/UI/Loaders/BounceLoader';

const delay = (ms: number) => {
	return new Promise((resolve) => {
		setTimeout(resolve, ms);
	});
};

export const loadableDelay: <T = any, >(promise: Promise<{ default: T } | T>) => Promise<{ default: T } | T> = (promise) => {
	if (typeof window === 'undefined') return promise;

	let promiseErr;

	// tslint:disable-next-line:no-parameter-reassignment
	promise = promise.catch((err) => promiseErr = err);

	return Promise.all([promise, delay(200)]).then((val) => (promiseErr ? Promise.reject(promiseErr) : val[0]));
};

export const defaultLazyImportOptions = {
	fallback: <Loader defaultLoader={<SimpleLoader />} type="chunkLoader" />,
	ssr: true,
};

export const lazyImport = <Props = unknown>(
	callBack: (props: any) => Promise<DefaultComponent<Props> | React.ComponentClass<Props>>,
	options: OptionsWithoutResolver<Props> = defaultLazyImportOptions,
): LoadableComponent<Props> | React.ComponentClass<Props> => {
	return loadableBase(
		(props) => loadableDelay(callBack(props)),
		options,
	);
};

const loadable = <Props = unknown>(
	callBack: (props: any) => Promise<DefaultComponent<Props> | React.ComponentClass<Props>>,
	options: OptionsWithoutResolver<Props> & { resolveComponent? } = defaultLazyImportOptions,
): LoadableComponent<Props> | React.ComponentClass<Props> => {
	return loadableBase(
		callBack,
		options,
	);
};

export default loadable;
